<template>
  <div class="next-billing">
    <app-loading :loading="loading">
      <template v-if="!loading">
        <div class="title">
          {{ $ml.get(`Next billing due date`) }}
        </div>
        <div class="value">
          {{ date }}
        </div>
      </template>
    </app-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PlansAPI } from '@/api';
export default {
  data() {
    return {
      loading: false,
      date: null,
    }
  },
  computed: {

    ...mapGetters({
      user: 'user/data',
    }),

    period() {
      return this.user.subsPeriod;
    },
  },
  created() {
    this.loading = true;
    PlansAPI.getNextBillingDate()
      .then(res => {
        this.date = res.data.next_billing_date;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
</script>

<style lang="scss" scoped>

.next-billing {
  background: #f7f7f7;
  flex-grow: 1;
  margin-right: 20px;
  border-bottom: 5px solid #eee;
  border-radius: 5px;
  padding: 10px;
  line-height: 1.5;
  max-width: 250px;
  &:last-child {
    margin-right: 0;
  }

  .title {
    margin-bottom: 10px;
  }

  .value {
    text-transform: capitalize;
    font-size: 26px;
    font-weight: bold;
  }
}

</style>
